import {
  Boxes, Container, Factory, BadgeCheck, Workflow, LayoutGrid, Ban, Layers,
  Users, ShoppingBasket, ClipboardCheck, Ship, ScanSearch, Warehouse,
  PackageCheck, Handshake, Boxes as BoxesIcon,
} from "lucide-react";

export const FEATURES = [
  { icon: Users, title: "Multiple Manufacturers", text: "Source from several verified Turkish manufacturers at once, without juggling separate relationships." },
  { icon: Container, title: "One Container", text: "Consolidate every product line into a single 40HQ shipment, optimised down to the last pallet." },
  { icon: Factory, title: "Factory Direct Purchasing", text: "Buy straight from the source. DeMaxtore never sits between you and the manufacturer." },
  { icon: Ban, title: "No Product Markups", text: "You pay factory prices. There are zero product markups — the value is coordination, not resale." },
  { icon: Workflow, title: "Procurement Coordination", text: "Quotes, orders, production, freight and inspection orchestrated as one connected operation." },
  { icon: LayoutGrid, title: "One Workspace", text: "Every manufacturer, document and milestone lives inside a single procurement Workspace." },
];

export const FRAGMENTED = [
  "Multiple suppliers to chase", "Multiple quotations to reconcile", "Multiple production schedules",
  "Multiple purchase orders", "Multiple sets of documents", "Multiple follow-ups",
  "Multiple freight discussions", "Disconnected communication",
];

export const CONSOLIDATED = [
  "One connected Workspace", "One consolidated quotation view", "One synchronised timeline",
  "One coordinated purchase flow", "One document hub", "One source of truth",
  "One freight booking", "One clear line of communication",
];

export const WORKFLOW = [
  { icon: ShoppingBasket, label: "Select Products" },
  { icon: Users, label: "Choose Manufacturers" },
  { icon: Container, label: "Build SmartContainer™" },
  { icon: Factory, label: "Manufacturers Prepare Orders" },
  { icon: Workflow, label: "DeMaxtore Coordinates Procurement" },
  { icon: Warehouse, label: "Container Consolidation" },
  { icon: Ship, label: "Freight Booking" },
  { icon: ScanSearch, label: "Inspection" },
  { icon: PackageCheck, label: "Shipment" },
];

export const ECOSYSTEM = [
  { label: "SmartContainer™", icon: Container },
  { label: "Purchase Order", icon: ClipboardCheck },
  { label: "FreightIQ™", icon: Ship },
  { label: "Inspection™", icon: ScanSearch },
  { label: "Live Shipment Tracking™", icon: LayoutGrid },
  { label: "Delivered", icon: PackageCheck },
];

export const OUTCOMES = [
  { icon: Factory, title: "Factory Direct Purchasing", text: "Preserve direct manufacturer relationships and factory-gate pricing across every line item." },
  { icon: Users, title: "Fewer Suppliers To Manage", text: "Replace a web of vendor threads with one coordinated procurement operation." },
  { icon: Workflow, title: "Single Procurement Operation", text: "Run sourcing, ordering and shipping as one motion instead of many disconnected tasks." },
  { icon: Handshake, title: "Lower Coordination Effort", text: "DeMaxtore absorbs the operational overhead so your team focuses on decisions, not chasing." },
  { icon: Container, title: "One Shipment", text: "Everything arrives together in a single optimised container — no fragmented deliveries." },
  { icon: LayoutGrid, title: "One Workspace", text: "A permanent, auditable home for the entire multi-manufacturer procurement lifecycle." },
];

export const FAQ = [
  { q: "What is SmartContainer™?", a: "SmartContainer™ is a DeMaxtore procurement model that lets importers build a single container filled with products sourced directly from multiple verified Turkish manufacturers. It is not a marketplace and not a reseller — it is an intelligent way to coordinate multi-manufacturer procurement inside one connected Workspace." },
  { q: "Can I buy from multiple manufacturers?", a: "Yes. That is the core idea. You can combine product lines from several verified Turkish manufacturers into one SmartContainer™, while DeMaxtore keeps every order, schedule and document coordinated in a single operation." },
  { q: "Do I buy directly from manufacturers?", a: "Always. Purchasing is factory direct — you buy straight from each manufacturer. DeMaxtore never becomes the buyer or seller of your products; it coordinates the procurement process on your behalf." },
  { q: "Does DeMaxtore add product markups?", a: "No. There are zero product markups. You pay each manufacturer their factory price. DeMaxtore's value comes from intelligent procurement coordination, not from marking up goods." },
  { q: "Can I use my existing suppliers?", a: "Yes. Your existing verified manufacturer relationships can be brought into a SmartContainer™ Workspace, so you keep the partners you trust while gaining coordinated, single-container procurement." },
  { q: "How does SmartContainer™ connect with FreightIQ™?", a: "Once your SmartContainer™ is built and orders are placed, it flows directly into FreightIQ™ for freight booking, then into Inspection™ and Live Shipment Tracking™ — one seamless operational workflow from purchase order to delivered." },
];

export const CONTAINER_PRODUCTS = [
  { name: "Tomato Paste", pallets: 4, color: "#ef4444" },
  { name: "Pasta", pallets: 3, color: "#f59e0b" },
  { name: "Wheat Flour", pallets: 3, color: "#a16207" },
  { name: "Sunflower Oil", pallets: 3, color: "#eab308" },
  { name: "Bulgur", pallets: 3, color: "#d97706" },
  { name: "Pulses", pallets: 2, color: "#16a34a" },
];

export const ICONS = { Boxes, BoxesIcon, BadgeCheck, Layers };
